import { render, staticRenderFns } from "./voucherGoodsList.vue?vue&type=template&id=24e0a715&scoped=true"
import script from "./voucherGoodsList.vue?vue&type=script&lang=js"
export * from "./voucherGoodsList.vue?vue&type=script&lang=js"
import style0 from "./voucherGoodsList.vue?vue&type=style&index=0&id=24e0a715&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0a715",
  null
  
)

export default component.exports